export default __webpack_public_path__ + "fec09bd55c5810aa793d749ba976dd64.png";